module.exports = __webpack_public_path__ + "img/2.bef0bef3.png";